import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {slotStore, strictUiEmitter} from '@gongxigames/framework/slotV2/globals';
import {GameConfig} from '@gongxigames/framework/slot/types';
import {inject} from '@gongxigames/framework/core/installer';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {DefaultEventsMap, IEventManagerWithAsync} from '@gongxigames/framework/core/types';
import {UIBalanceStore} from './UIBalanceStore';
import { UpdateManager} from '@gongxigames/framework/core';

export class UIBalanceService extends UiServiceV2 {
    public static NAME = 'UIBalanceService';

    @inject(CoreDI.GameConfig)
    protected gameConfig!: GameConfig;

    /**
     * // TODO: refactor
     * @deprecated
     */
    @inject(CoreDI.IEventManagerWithAsync)
    protected _eventManager!: IEventManagerWithAsync<DefaultEventsMap>;

    @inject(CoreDI.UpdateManager)
    protected _updateManager!: UpdateManager;

    public onSetupEvents(): void {
        this.emitter.on('LogicEvents.BALANCE_UPDATED', this.updateBalance.bind(this));
        this.emitter.on('Game.command.refreshBalance', this.updateBalance.bind(this));
    }

    private updateBalance() {
        slotStore.reComputeLogicTrigger.value++;
        const balance = slotStore.logic_balance.value;

        this._eventManager.emit('General.UI.BALANCE.UPDATED', balance);
        strictUiEmitter.emit('UI.command.balanceUpdated', balance);
        UIBalanceStore.slot_ui_label_balance.value = balance;
    }
}